import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAllServices } from "@/hooks/useHotelServices";
import { useTranslation } from "react-i18next";

interface BillingTransactionServiceFieldProps {
  hotelId?: string;
  value?: string;
  onChange: (value: string) => void;
  triggerClassName?: string;
}

const BillingTransactionServiceField = ({
  hotelId,
  value,
  onChange,
  triggerClassName,
}: BillingTransactionServiceFieldProps) => {
  const { t } = useTranslation();
  const { data, isLoading } = useAllServices(hotelId ?? "");

  return (
    <Select value={value ?? "all services"} onValueChange={onChange}>
      <SelectTrigger
        disabled={!hotelId || isLoading}
        className={triggerClassName}
      >
        <SelectValue
          placeholder={
            !hotelId
              ? t("billing.selectHotelFirst")
              : t("billing.servicePlaceholder")
          }
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all services">{t("billing.allServices")}</SelectItem>
        {data?.data.map((service) => (
          <SelectItem key={service.id} value={service.id}>
            {service.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default BillingTransactionServiceField;
